import { pickContextTypes } from '../../context-types';
import videoSources from 'widget/player-widget/constants/video-sources';

import Vimeo from './vimeo';
import Youtube from './youtube';
import Facebook from './facebook';


const playersMap = {
  [videoSources.YOUTUBE]: Youtube,
  [videoSources.VIMEO]: Vimeo,
  [videoSources.FACEBOOK]: Facebook,
};

const getNextExternalUrl = props => _.get(props, 'videoItem.mediaExternUrl');

export default class External extends React.Component {

  static propTypes = {
    videoItem: React.PropTypes.object.isRequired,
    width: React.PropTypes.number,
    height: React.PropTypes.number,
    className: React.PropTypes.string,
  };

  static contextTypes = pickContextTypes(
    'simple',
    'mobileMode',
    'paused',
    'loop',
    'muted',
    'toggleBeenPlayed',
    'beenPlayed',
    'showControls'
  );

  componentDidMount() {
    this.context.toggleBeenPlayed(!this.context.paused);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const nextVideoUrl = getNextExternalUrl(nextProps);

    if (nextVideoUrl && nextVideoUrl !== getNextExternalUrl(this.props)) {
      this.context.toggleBeenPlayed(false);
    }

    if (!nextContext.paused && !nextContext.beenPlayed) {
      this.context.toggleBeenPlayed(true);
    }
  }

  render() {
    const { videoItem } = this.props;

    if (!videoItem) {
      return null;
    }

    const { id, externalId, mediaExternUrl, videoSource } = videoItem;

    const props = {
      ..._.pick(this.props, 'className', 'width', 'height'),
      ..._.omit(this.context, 'videoItem', 'toggleBeenPlayed', 'beenPlayed'),
      src: mediaExternUrl,
    };

    const ExternalPlayer = playersMap[videoSource];

    if (!ExternalPlayer) {
      return null;
    }

    return (
      <ExternalPlayer {...props}
                      key={id || externalId} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/video/external/external.js